/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudWireIcon16Light = forwardRef('NetCloudWireIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 12h3.25a4.25 4.25 0 0 0-.082-8.5 4.126 4.126 0 0 0-7.911 1.388A3.626 3.626 0 0 0 4.25 12H7v2H3.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1H8v-2ZM4.25 5.125a3.125 3.125 0 0 1 6.1-.96.5.5 0 0 0 .515.345 3.25 3.25 0 1 1 .34 6.49H4.25a2.625 2.625 0 0 1-.418-5.217.5.5 0 0 0 .421-.516 3.18 3.18 0 0 1-.003-.142Z" })));
});
